function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 8.5,
  cy: 8.5,
  r: 8.5,
  stroke: "#3CB950",
  strokeWidth: 0.3
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3CB950",
  fillRule: "nonzero",
  d: "M12.231 4.468A1.585 1.585 0 0 0 11.101 4c-.426 0-.827.166-1.129.468L5.168 9.245a.27.27 0 0 0-.064.1l-1.088 2.99a.273.273 0 0 0 .336.353l2.705-.83a.272.272 0 0 0 .112-.067l5.063-5.063c.302-.301.468-.703.468-1.13 0-.427-.166-.828-.469-1.13zm-5.487 6.917l-1.013.311a1.162 1.162 0 0 0-.276-.452 1.47 1.47 0 0 0-.368-.26l.463-1.275h.625v.544c0 .15.122.272.272.272h.48l-.183.86zm4.002-3.94l-3.313 3.312.096-.447a.272.272 0 0 0-.266-.329h-.544v-.544a.272.272 0 0 0-.272-.272h-.429l3.233-3.214.004.003c.199-.2.464-.31.745-.31.281 0 .547.11.746.31a1.05 1.05 0 0 1 0 1.49zm1.1-1.101l-.253.253a1.587 1.587 0 0 0-1.492-1.49l.255-.254c.199-.2.464-.31.746-.31.281 0 .546.11.745.31.2.199.31.464.31.745 0 .282-.11.547-.31.746zm-1.785-.09l-2.719 2.72a.272.272 0 1 0 .385.384l2.718-2.719a.272.272 0 1 0-.384-.384z"
}));

var SvgEdit = function SvgEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit.0a6c3dd0.svg";
export { ForwardRef as ReactComponent };